/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

import PrivacyPages from '../../components/PrivacyPages';

class CookiesPage extends React.Component {
  render() {
    return <PrivacyPages page="cookies" />;
  }
}

export default CookiesPage;



// WEBPACK FOOTER //
// ./src/routes/cookies/Cookies.js